









































import { Vue, Component, Prop, Model } from 'vue-property-decorator';

@Component({
  name: 'ToggleDesign',
})
export default class ToggleDesign extends Vue {
  @Prop({type: Array, default: () => []}) public readonly items!: [];
  @Prop({type: Boolean, default: false}) public readonly isMobile!: boolean;
  @Model('change', { type: Number, default: 0 }) public readonly active: number = 0;

  public get toggle() {
    return this.items[this.active];
  }

  public set toggle(value) {
    const index = this.items.findIndex((it: any) => it.id === value);
    this.$emit('change', index);
  }

}
